import { useMemo, useContext, ReactNode } from 'react';
import panelClasses from '../../common/styles/overview-panel.module.css';
import { TaxonHypothesis, loadNumberOfITSSequences, loadNumberOfSHs } from '../utils/api';
import { AsyncValue } from '../../common/components/Async';
import { ConfigContext } from '../../common/utils/config';

interface Props {
    taxonHypothesis: TaxonHypothesis;
}

function Field(props: { label: string, children: ReactNode }) {
    return (
        <tr>
            <td className={panelClasses.tableCell}>
                <label className={panelClasses.label}>
                    {props.label}
                </label>
            </td>

            <td className={panelClasses.tableCell}>
                {props.children}
            </td>
        </tr>
    );
}

export default function Statistics({ taxonHypothesis }: Props) {
    const config = useContext(ConfigContext);

    const taxonName = taxonHypothesis.taxon.taxon_name;

    // Note: this run twice in dev, because of React.StrictMode
    const numberOfSHs = useMemo(() => loadNumberOfSHs(config, taxonHypothesis), [config, taxonHypothesis]);
    const numberOfITSSequences = useMemo(() => loadNumberOfITSSequences(config, taxonHypothesis), [config, taxonHypothesis]);

    return (
        <div className={panelClasses.panel}>
            <header className={panelClasses.header}>
                Statistics
            </header>

            <table className={panelClasses.table}>
                <tbody>
                    <Field label={'Number of SHs'}>
                        <AsyncValue promise={numberOfSHs}>
                            {(value) => <span>{value}</span>}
                        </AsyncValue>
                    </Field>

                    <Field label={'Number of ITS sequences'}>
                        <AsyncValue promise={numberOfITSSequences}>
                            {(value) => <span>{value}</span>}
                        </AsyncValue>
                    </Field>

                    <Field label={`Number of SHs identified as ${taxonName} sp.`}>
                        {taxonHypothesis.dshcluster_count}
                    </Field>

                    <Field label={`Number of ITS sequences within SHs identified as ${taxonName} sp.`}>
                        {taxonHypothesis.its_sequence_count}
                    </Field>
                </tbody>
            </table>
        </div>
    );
};
